import { useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import { useLocation } from "react-router-dom";
import { ReactComponent as PlanDetails } from '../../assets/images/plan-details.svg';
import { Col, Row } from "reactstrap";
import SubscribeModal from "../../components/Modals/Subscribe";
import { nl2br, tField } from "../../utils/helpers";
import { useTranslation } from "react-i18next";
import './styles.css';

function PlanPage() {
  const { t } = useTranslation('plans');
  const location = useLocation();  
  const [plan, setPlan] = useState(location?.state?.plan || null);
  const [subscribeModalShown, setSubscribeModalShown] = useState(false);

  return(
    <MainLayout
      isTopBar
      screenTitle={plan?.name_ar}
    >
      <Row className="justify-content-center mx-0">
        <Col lg="6" md="8" className="px-0">
          <div className="p-3">
            <div className='text-center mb-4 position-relative'>
              <PlanDetails />

              <div className='view-plan-details-card'>
                <div className='mb-3 text-white'>{ plan?.discount }% {t('discount')}</div>
                <div className='mb-3' style={{color: '#f7b612'}}>{ plan?.normal_offers_count } اعلان</div>
                <div className='mb-3 text-white'>{ plan?.price } {t('currency')}</div>
              </div>
            </div>

            <Row>
              <Col xs="6">
                <h6>{t('view.months_count')}</h6>
                <span>{ plan?.months_count }</span>
              </Col>
              <Col xs="6">
                <h6>{t('view.ads_count')}</h6>
                <span>{ plan?.normal_offers_count }</span>
              </Col>
            </Row>

            <hr />

            <div>
              <h6>{t('view.price')}</h6>
              <span>{ plan?.price } {t('currency')}</span>
            </div>

            <hr />

            <div>
              <h6>{t('view.description')}</h6>
              <span dangerouslySetInnerHTML={{__html: nl2br(tField(plan, 'description'))}}></span>
            </div>
            
            <div className="text-center mt-5">
              <button className='btn btn-primary' onClick={() => setSubscribeModalShown(true)}>{t('view.button')}</button>
            </div>
          </div>
        </Col>
      </Row>

      <SubscribeModal 
        isOpen={subscribeModalShown} 
        toggle={() => setSubscribeModalShown(!subscribeModalShown)}
        plan={plan}
      />
    </MainLayout>
  );
}

export default PlanPage;